var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKafka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Apache Kafka") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 0C5.37 0 0 5.37 0 11.996s5.37 11.996 11.996 11.996 11.996-5.37 11.996-11.996S18.622 0 11.996 0zm0 1.5c5.8 0 10.5 4.7 10.5 10.5s-4.7 10.5-10.5 10.5-10.5-4.7-10.5-10.5 4.7-10.5 10.5-10.5zm-5.5 5.5v9l7.5-4.5-7.5-4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKafka);
export default __webpack_public_path__ + "static/media/kafka.3c57b889c84cccbad830e48c3fa6ffd7.svg";
export { ForwardRef as ReactComponent };